/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Reelplicate API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

/**
 * @summary The accounts the workspace publishes to, by platform.
 */
export const ListSocialAccountsParams = zod.object({
  id: zod.string(),
});

export const ListSocialAccountsResponseItem = zod.object({
  platform: zod.enum(['TIKTOK', 'INSTAGRAM', 'YOUTUBE', 'LINKEDIN', 'FACEBOOK']),
  statsStatus: zod
    .enum(['PENDING', 'ACTIVE', 'NOT_FOUND', 'ERROR'])
    .describe('Whether the stats sync could read it (public data, by handle).')
    .describe('Whether the stats sync could read it (public data, by handle).'),
  id: zod.string(),
  handle: zod.string(),
  personaId: zod
    .string()
    .nullable()
    .describe('The persona it posts for, or null for the brand itself.'),
  statsError: zod
    .string()
    .nullable()
    .describe('Why the last read failed, when statsStatus is NOT_FOUND or ERROR.'),
  createdAt: zod.iso.datetime({ offset: true }),
});
export const ListSocialAccountsResponse = zod.array(ListSocialAccountsResponseItem);

/**
 * @summary Add an account for the brand or one of its personas.
 */
export const CreateSocialAccountParams = zod.object({
  id: zod.string(),
});

export const createSocialAccountBodyHandleMax = 100;

export const CreateSocialAccountBody = zod.object({
  platform: zod.enum(['TIKTOK', 'INSTAGRAM', 'YOUTUBE', 'LINKEDIN', 'FACEBOOK']),
  handle: zod
    .string()
    .min(1)
    .max(createSocialAccountBodyHandleMax)
    .describe("The account's handle, or its channel name on YouTube."),
  personaId: zod
    .uuid()
    .nullish()
    .describe('The persona it posts for. Leave it out (or null) for the brand itself.'),
});

export const CreateSocialAccountResponse = zod.object({
  platform: zod.enum(['TIKTOK', 'INSTAGRAM', 'YOUTUBE', 'LINKEDIN', 'FACEBOOK']),
  statsStatus: zod
    .enum(['PENDING', 'ACTIVE', 'NOT_FOUND', 'ERROR'])
    .describe('Whether the stats sync could read it (public data, by handle).')
    .describe('Whether the stats sync could read it (public data, by handle).'),
  id: zod.string(),
  handle: zod.string(),
  personaId: zod
    .string()
    .nullable()
    .describe('The persona it posts for, or null for the brand itself.'),
  statsError: zod
    .string()
    .nullable()
    .describe('Why the last read failed, when statsStatus is NOT_FOUND or ERROR.'),
  createdAt: zod.iso.datetime({ offset: true }),
});

/**
 * @summary Change an account's handle or who it posts for.
 */
export const UpdateSocialAccountParams = zod.object({
  id: zod.string(),
  accountId: zod.string(),
});

export const updateSocialAccountBodyHandleMax = 100;

export const UpdateSocialAccountBody = zod.object({
  handle: zod
    .string()
    .min(1)
    .max(updateSocialAccountBodyHandleMax)
    .optional()
    .describe("The account's handle, or its channel name on YouTube."),
  personaId: zod
    .uuid()
    .nullish()
    .describe('The persona it posts for. Leave it out (or null) for the brand itself.'),
});

export const UpdateSocialAccountResponse = zod.object({
  platform: zod.enum(['TIKTOK', 'INSTAGRAM', 'YOUTUBE', 'LINKEDIN', 'FACEBOOK']),
  statsStatus: zod
    .enum(['PENDING', 'ACTIVE', 'NOT_FOUND', 'ERROR'])
    .describe('Whether the stats sync could read it (public data, by handle).')
    .describe('Whether the stats sync could read it (public data, by handle).'),
  id: zod.string(),
  handle: zod.string(),
  personaId: zod
    .string()
    .nullable()
    .describe('The persona it posts for, or null for the brand itself.'),
  statsError: zod
    .string()
    .nullable()
    .describe('Why the last read failed, when statsStatus is NOT_FOUND or ERROR.'),
  createdAt: zod.iso.datetime({ offset: true }),
});

/**
 * @summary Remove an account.
 */
export const DeleteSocialAccountParams = zod.object({
  id: zod.string(),
  accountId: zod.string(),
});

export const DeleteSocialAccountResponse = zod.void();

/**
 * @summary Read the account's public numbers now, whatever the last read said: a
handle marked not found or failed is asked about afresh.
 */
export const CheckSocialAccountParams = zod.object({
  id: zod.string(),
  accountId: zod.string(),
});

export const CheckSocialAccountResponse = zod.object({
  statsStatus: zod
    .enum(['PENDING', 'ACTIVE', 'NOT_FOUND', 'ERROR'])
    .describe('Whether the stats sync could read it (public data, by handle).'),
  id: zod.string(),
  statsError: zod
    .string()
    .nullable()
    .describe('Why the read failed, when statsStatus is NOT_FOUND or ERROR.'),
});
